export enum SalesType {
  renewal = 'Renewal',
  acquisition = 'Acquisition',
  unknown = 'Unknown',
}
